import { render } from "@projectComps/CategoryDeleteConfirm/CategoryDeleteConfirm.html?vue&type=template&id=10da140a&external"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "@projectComps/CategoryDeleteConfirm/CategoryDeleteConfirm.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__